import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { useInvalidateTimeBlockNotes } from '@/api/reservations/get-time-block-notes'
import { useInvalidateTimeBlocks } from '@/api/reservations/get-time-blocks'

import { useInvalidateTimeBlockById } from './get-time-block-by-id'

export interface DeleteTimeBlockNoteRequest {
  timeBlockId: number
  noteId: number
}

export const deleteTimeBlockNote = async ({ timeBlockId, noteId }: DeleteTimeBlockNoteRequest) => {
  const response = await authAPI.delete(`/time-block/${timeBlockId}/notes/${noteId}`)
  return response.data
}

export const useDeleteTimeBlockNote = () => {
  const invalidateNotes = useInvalidateTimeBlockNotes()
  const invalidateTimeBlocks = useInvalidateTimeBlocks()
  const invalidateTimeBlock = useInvalidateTimeBlockById()

  return useMutation({
    mutationFn: deleteTimeBlockNote,
    onSuccess: (_, { timeBlockId }) => {
      invalidateNotes(timeBlockId)
      invalidateTimeBlocks()
      invalidateTimeBlock(timeBlockId)
    },
  })
}
